import React from 'react'
import Header from './header'
import Footer from './footer'
import { injectIntl } from 'gatsby-plugin-intl'
import styled, { createGlobalStyle } from 'styled-components'
import { Normalize } from 'styled-normalize'
import { breakpoints } from '../utils/utils'
import Cookies from '../components/Cookies'
import '../utils/fonts/fonts.css'

const GlobalStyles = createGlobalStyle`

  *, 
  *::before, 
  *::after {
    box-sizing: inherit;
  }

  *:focus {
    outline: none;
  }

  ul {
    list-style: none;
  }

  html {
    box-sizing: border-box;
    position: relative;
    
    ${breakpoints.xxl} {
      font-size: 112.5%;    /* 1rem = 18px */
    }

    ${breakpoints.lg} { 
      font-size: 100%;      /* 1rem = 16px */
    }

    ${breakpoints.md} {  
      font-size: 87.5%;     /* 1rem = 14px */
    }

    ${breakpoints.sm} {  
      font-size: 75%;       /* 1rem = 12px */
    }
  }

  body,select,label {
    font-family: Avenir, sans-serif;
  }

  h1,h2,h3 {
    font-family: Avenir-Bold, sans-serif;
  }

  pre {
    white-space: break-spaces;
  }

  #gs div, #gs h1, #gs p, #gs path {
    z-index: 100!important;
  }
  
  #gs .gs1t {
    max-height: calc(100% - 200px) !important;
    ${breakpoints.md} {
      max-height: none !important;
      height: calc(100% - 120px - 1rem) !important;
      margin-top: calc(120px + 1rem) !important;
    }
  }

  .hidden {
    display: none!important;
  }

  .title-hidden {
    font-size: 0;
    width: 1px;
    height: 1px;
    display: inline-block;
    overflow: hidden;
    position: absolute!important;
    border: 0!important;
    padding: 0!important;
    margin: 0!important;
    clip: rect(1px,1px,1px,1px);
  }

  jdiv[class^="globalClass_"] * {
      z-index: 1450!important;
  }
`

export default injectIntl(({children}) => {
  return (
    < >
        <Normalize/>
        <GlobalStyles/>
        <Header />
        <Main>
          {children}
        </Main>
        <Footer/>
        <Cookies />
    </>
  )
})

const Main = styled.main`
  min-height: 100vh;
`